var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'modal':true, 'show':_vm.show}},[_c('div',{staticClass:"bg-overlay"}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[(_vm.loading)?_c('div',{staticClass:"loader-box"},[_c('i',{staticClass:"fas fa-spinner fa-spin fa-fw fa-2x"}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.msg))])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7205e8ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RsvpDetails/AsapModal.vue
// module id = 1827
// module chunks = 0